module.exports = __webpack_public_path__ + "static/media/audio.30a1ea02.svg";